import * as React from "react";
import { forwardRef } from "react";
const SvgTrendup = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: "current", viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 1H19M19 1V9M19 1L11 9L7 5L1 11", stroke: "current", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTrendup);
export default ForwardRef;
